// frontend/src/pages/pceDocumentDetailPage.jsx
import React from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiTarget, FiCheckSquare, FiLoader } from 'react-icons/fi';
import DocumentSection from '../../components/documents/DocumentSection';
// Importez les composants nécessaires (DocumentSection, etc.)

const PCEDocumentDetailPage = ({ 
    pces, 
    requiredDocuments,
    isUploading, 
    onFileChange, 
    onFileRemove, 
    fournisseurs, 
    userProfile, 
    session,
    updateDocument
}) => {
    const { pceId } = useParams();
    const navigate = useNavigate();

    const pce = pces.find(p => p.id === pceId);

    if (!pce) {
        return <div>Chargement ou pce non trouvé...</div>; // Ou une meilleure page d'erreur/chargement
    }

    const handleFinalizepceCollection = async () => {
        // Logique pour marquer la collecte de CE pce comme terminée
        // await supabase.from('pce').update({ documents_completed_at: new Date() }).eq('id', pce.id);
        // await onDataChange(); // Rafraîchir
        navigate('/dashboard/pce-documents');
    };

    return (
    <div>
      <Link to="/dashboard/pce-documents" className="inline-flex items-center text-sm text-gray-600 hover:text-gray-900 mb-6">
        <FiArrowLeft className="mr-2" />
        Retour à la liste des pce
      </Link>

      <div className="flex items-center mb-8">
        <div className="p-3 bg-green-100 rounded-full mr-4">
          <FiTarget className="w-6 h-6 text-green-600" />
        </div>
        <div>
          <h1 className="text-3xl font-bold text-gray-900">{pce.site_name}</h1>
          <p className="text-gray-500 font-mono">{pce.pce_number}</p>
        </div>
      </div>

      <div className="space-y-8">
        {requiredDocuments.map(docDef => { // On utilise les accolades {} pour un bloc de code sur plusieurs lignes

          // ✅ LA CORRECTION EST ICI : On déclare la constante avant de l'utiliser
          const docForpce = {
            ...docDef,
            files: (docDef.files || []).filter(file => file.pce_id === pce.id)
          };

          // Maintenant on peut retourner le JSX qui utilise cette constante
          return (
            <DocumentSection
              key={`${pce.id}-${docDef.id}`}
              document={docForpce}
              pce={pce} // ✅ On passe le pce au lieu du PDL
              isUploading={isUploading}
              onFileChange={onFileChange}
              onFileRemove={onFileRemove}
              fournisseurs={fournisseurs}
              userProfile={userProfile}
              session={session}
              updateDocument={updateDocument}
            />
          );
        })}
      </div>

      <div className="mt-12 bg-white rounded-xl shadow-lg p-8">
        <h3 className="text-2xl font-bold text-gray-900 mb-4">Finaliser la collecte pour ce pce</h3>
        <p className="text-gray-600 mb-6">
          Une fois que vous avez téléversé tous les documents nécessaires pour {pce.site_name},
          validez cette étape pour que notre équipe puisse commencer la vérification.
        </p>
        <button
          onClick={handleFinalizepceCollection}
          className="inline-flex items-center justify-center px-6 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700"
        >
          <FiCheckSquare className="mr-2" />
          J'ai terminé pour ce pce
        </button>
      </div>
    </div>
  );
};

export default PCEDocumentDetailPage;